import React, { useState, useEffect, useRef } from "react";
import footbal from "../../../../../assets/customerAssets/football.png";
import { Box, Button, ImageListItem, FormHelperText } from "@mui/material";
// import cameraIcon from "../../../assets/customerAssets/icons/camera.svg";
import cameraIcon from "../../../../../assets/customerAssets/icons/camera.svg";
// import { supportedImageFileTypes } from "../../../helper/commonFunctions";
import { supportedImageFileTypes } from "../../../../../helper/commonFunctions";
import { toast } from "react-toastify";
import styles from "./styles.module.css";

const FormProfileComponent = ({ formik }) => {
  const [imgPreview, setImgPreview] = useState(null);
  //   const [imgPreview, setImgPreview] = useState(() =>
  //     formik.values.club_img instanceof File
  //       ? URL.createObjectURL(formik.values.club_img)
  //       : formik.values.club_img,
  //   );

  useEffect(() => {
    if (formik.values.club_img instanceof File) {
      setImgPreview(URL.createObjectURL(formik.values.club_img));
    } else {
      setImgPreview(formik.values.club_img);
    }
  }, [formik.values.club_img]);
  const imageInputRef = useRef(null);

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      toast.error("Please select a file");
      return;
    }
    const fileType = file.type.split("/")[1];
    const fileExt = file.name.split(".").pop().toLowerCase();

    if (
      supportedImageFileTypes.includes(file.type) === false &&
      supportedImageFileTypes.includes(fileExt) === false
    ) {
      toast.error("Please select a valid image file");
      return;
    }

    setImgPreview(URL.createObjectURL(file));
    formik.setFieldValue("club_img", file);
    formik.setFieldTouched("club_img", true);
  };

  return (
    <>
      <Box className={styles.wrapper}>
        <input
          type="file"
          name="image"
          onChange={handleChange}
          onBlur={formik.handleBlur}
          style={{ display: "none" }}
          ref={imageInputRef}
        />

        {/* If Preview Exists */}
        {imgPreview ? (
          <div className={styles.previewContainer}>
            <img
              src={imgPreview}
              alt="preview"
              className={styles.previewImage}
            />

            {/* Tooltip Full Image */}
            <div className={styles.tooltip}>
              <img src={imgPreview} alt="full-preview" />
            </div>

            {/* Change Image Button */}
            <Button
              className={styles.editButton}
              onClick={() => imageInputRef.current.click()}
            >
              Change
            </Button>
          </div>
        ) : (
          /* Upload Button (No Preview) */
          <Button
            className={styles.uploadButton}
            onClick={() => imageInputRef.current.click()}
          >
            Upload Club Image
          </Button>
        )}
      </Box>

      {formik.touched.club_img && !formik.values.club_img && (
        <FormHelperText sx={{ color: "red" }}>
          Club Image is required.
        </FormHelperText>
      )}
    </>
  );
};

export default FormProfileComponent;
